import { render } from "./RoomJungle.vue?vue&type=template&id=4c88204e&ts=true"
import script from "./RoomJungle.vue?vue&type=script&lang=ts"
export * from "./RoomJungle.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__